import { Route, Routes } from "react-router";
import HeyVetHeaderComponent from "./HeyVetHeaderComponent";
import HeyVetFooterComponent from "./HeyVetFooterComponent";
import HeyVetHomeContentPage from "./HeyVetHomeContentPage";

export default function HeyVetLayoutPage() {
    return (
        <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
            <HeyVetHeaderComponent />
            <main style={{ flex: 1 }}>
                <Routes>
                    <Route path="/" element={<HeyVetHomeContentPage />} />
                    {/* Add more routes here later (e.g. /services, /contact) */}
                </Routes>
            </main>
            <HeyVetFooterComponent />
        </div>
    );
}
